<script>
export default {
    name: 'CpStateIcon',
    components: {
        CpBaseSvgIcon: require('../../base-svg-icon').default,
    },
    props: {
        americanState: { type: String, default: '' },
        color: Boolean,
        noMargin: Boolean,
        groupStyle: { type: Boolean, default: false },
        groupFeedStyle: { type: Boolean, default: false },
    },
    computed: {
        stateIcon() {
            return () => import(`./states/${this.americanState}`);
        },
    },
};
</script>
<template>
    <span :class="[groupStyle ? 'state-icon-group' : groupFeedStyle ? 'state-icon-group-feed' : 'state-icon-content', noMargin ? 'mt-0' : '']">
        <component v-bind:is="stateIcon" :style="{ color: color ? '#ff4814' : 'white' }" />
    </span>
</template>
<style>
span.state-icon-group-feed {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 150px;
    width: 100%;
    margin-top: 30px;
}
span.state-icon-group svg.vertical {
    height: 100%;
    width: auto;
}
span.state-icon-group svg.horizontal {
    width: 100%;
    height: 100%;
}
span.state-icon-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    width: 100%;
}
.mt-0 {
    margin-top: 0px !important;
    justify-content: normal !important;
}
span.state-icon-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 275px;
    width: 100%;
    margin-top: 30px;
}
span.state-icon-group-feed svg.vertical,
span.state-icon-content svg.vertical {
    height: 90%;
    width: auto;
}
span.state-icon-group-feed svg.horizontal,
span.state-icon-content svg.horizontal {
    width: 90%;
    height: auto;
}
@media only screen and (max-width: 767px) {
    span.state-icon-group svg.vertical {
        height: 100%;
        width: auto;
    }
    span.state-icon-group svg.horizontal {
        width: 100%;
        height: 80%;
    }
    span.state-icon-group {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
}
</style>
